import React, { useEffect, useRef, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { useSelector, useDispatch } from "react-redux";
import { ErrorToast, SuccessToast } from "../../../ToastComponent/RectHotToast";
import PortalFooter from "../../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../../Components/Reactportal/Reactportal";
import "../.././FormComponent.scss";
import { useCallback } from "react";
import useKeyDown from "../../AddLoad/text";
import { getUserName } from "../../../../../CommonFunction/GetUserInfo";
import { GetTodaysDateINdmy } from "../../../../../CommonFunction/GetTodaysDate";
import { ReceivedPODProcessSection } from "./AddReceivedPODsProcessSection/AddReceivedPODsProcessSection";

const POD_Sending = gql`
  mutation Pod_Sending($editPOD_Management_TO_POD_Process_Input: editPOD_Management_TO_POD_Process_Input) {
    editPOD_Management_TO_Process(editPOD_Management_TO_POD_Process_Input: $editPOD_Management_TO_POD_Process_Input) {
      _id
    }
  }
`;

const formField = {
  POD_Received_By: getUserName(),
  POD_Received_Date: GetTodaysDateINdmy(),
};

const AddReceivedPODs = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const [processingPOD] = useMutation(POD_Sending);
  const [toggle, settoggle] = useState(false);
  const [alldata, setalldata] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const FormData = useSelector((store) => store.FormFieldData);
  const submitFunctionCalled = useRef(true);
  // eslint-disable-next-line
  const [FormField, setFormField] = useState({ ...formField });
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    setalldata(FormData.fielddata);
  }, [FormData]);
  useEffect(() => {
    setSelectedRows(fielddataRedux?.Received_PODs?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);
  const submit = async () => {
    let data = {};
    for (let key in alldata) {
      data = {
        ...data,
        ...alldata[key],
      };
    }
    if (TypeOfPortal === "Received POD Process") {
      let Ids = selectedRows.map((el) => {
        return el._id;
      });
      await processingPOD({
        variables: {
          editPOD_Management_TO_POD_Process_Input: {
            Ids: [...Ids],
          },
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });

          SuccessToast("POD submitd");
          Closeformfunction();
        })
        .catch((err) => ErrorToast(err.message));
    }
  };
  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
    setFormField({ ...formField });
  };

  const HandleKeyDownf3 = useCallback(
    (event) => {
      event.stopPropagation();
      if (event.keyCode === 27) {
        return Closeformfunction();
      } else if (event.keyCode === 114) {
        if (submitFunctionCalled.current) {
          submitFunctionCalled.current = false;
          return;
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Closeformfunction, submit]
  );
  useKeyDown(HandleKeyDownf3);

  if (TypeOfPortal === "Received POD Process") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={TypeOfPortal}>
        <div className="PODProcessContainer">
          <ReceivedPODProcessSection selectedRows={selectedRows} />
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={submitType}
          SaveAndClose={() => {
            Closeformfunction();
            submit("close");
          }}
          handleformclose={() => {
            Closeformfunction();
            settoggle(!toggle);
          }}
        />
      </Reactportal>
    );
  }
};

export default AddReceivedPODs;
